import { Paths } from "configs";

import ReportDistributionDetail from "../components/ReportDistributionDetail";

export const ReportDistributionDetailRoutes = [
  {
    path: Paths.reportDistributionDetailPath,
    element: <ReportDistributionDetail />,
  },
];
